import { useState, memo, useContext, useCallback } from "react";
import { selectStyles } from "constants/form"
import { useGetCities, useGetProvinces } from "hooks/useRequest/location/location"
import MainFormContext from "context/main-form"
import { ICity } from "rules/interface/city/city.interface";
import ReactGA from 'react-ga';
import { useAppContext } from "context/state";
import { scrollToTop } from "utils/general";
import Button from "components/_button/form/submit"
import { IProvince } from "rules/interface/province/province.interface";
import styles from "./steps.module.scss"
import Select from 'react-select'
import { useRouter } from "next/router";
import abTestService from "services/ab-test.service";





interface IError {
    province?: string
    city?: string
}

const FormLocationStep = () => {
    const { formConfigs } = useAppContext()

    const { query } = useRouter()

    const { values, setValues } = useContext(MainFormContext)

    const { data: provinceData, isLoading: provinceIsLoading, isSuccess: provinceIsSuccess } = useGetProvinces()

    const { data: cities, isLoading: citiesIsLoading, isSuccess: citiesIsSuccess } = useGetCities({
        enabled: Boolean(values?.province),
        params: {
            province: values?.province?._id
        }
    })

    const [errors, setErrors] = useState<IError>({});

    // validate input's
    // have two state for handle validation
    // one of them for all fields can validate
    // another one for save error message of each input error
    const validationError = () => {
        let error: IError = {};
        // by default form validate is true
        // if we have one error or more
        // return false and waiting for fill data by client
        let formIsValid = true;

        // province
        if (!values?.province) {
            formIsValid = false;
            error["province"] = "استان خود را انتخاب کنید";
        }

        // validate city of province
        if (!(cities?.data?.filter(res => res.stat === values.province?._id)?.find(res => res._id === values.city?._id))) {
            formIsValid = false;
            error["city"] = "شهر انتخابی جزو استان انتخاب شده نمیباشد";
            setValues(prev => ({ ...prev, city: null }))
        }

        // city
        if (!values?.city) {
            formIsValid = false;
            error["city"] = "شهر خود را انتخاب کنید";
        }

        setErrors(error);
        return formIsValid;
    }

    const onSubmit = useCallback(() => {
        if (validationError()) {
            if (!values.withinGoal) {
                // send google goal analytics when form submited
                ReactGA.event(formConfigs.submitEvent1 ?? {
                    category: 'Submit',
                    action: 'Click',
                    label: 'form-step1'
                });
            }

            // scroll to top
            if (!formConfigs.config?.includes("disableScroll")) {
                scrollToTop();
            }

            if (values.province.alias === "tehran" || values.province.alias === "alborz" || values.province.alias === "mazandaran" || values.province.alias === "isfahan") {
                if (!abTestService.getInstallmentUser()) abTestService.setInstallmentUser()
            } else abTestService.removeInstallmentUser()

            values.nextStep()
        }
    }, [values])




    return (
        <div className="flex flex-column h100 jcb flex-grow gap-30">
            <h4 className={styles.form_title}>
                {query?.title ? query.title : <>
                    برای دریافت مشاوره‌ی انتخاب بهترن مدل از کارشناسان ما، لطفا فرم را تکمل کنید.
                </>}
            </h4>

            <div className="flex-grow flex flex-column gap-25 jcc">
                <div className="flex flex-column align-i-center gap-10 jcc w100">
                    <div className={styles.form_item + " _validate relative input_block w100-mb flex flex-column jcc"}>
                        <label className={styles.wrapper__form_item}>
                            <span className={styles.label__wrapper}>استان</span>
                            <Select
                                className={`c-input relative p-0 w100-mb ${errors?.province ? "input_error" : ""}`}
                                placeholder="انتخاب کنید ..."
                                getOptionLabel={(option: IProvince) => option.name}
                                getOptionValue={(option: IProvince) => option._id}
                                options={provinceIsSuccess && provinceData?.data}
                                isLoading={provinceIsLoading}
                                openMenuOnClick
                                value={values?.province}
                                isRtl
                                isSearchable
                                onChange={(val: IProvince) => setValues(prev => ({ ...prev, province: val, city: null }))}
                                styles={selectStyles}
                                components={{
                                    ClearIndicator: null,
                                    IndicatorSeparator: null,
                                }}
                            />
                            {errors?.province && <span className="input_alert">{errors?.province}</span>}
                        </label>
                    </div>

                    <div className={styles.form_item + " _validate input_block w100-mb flex flex-column jcc"}>
                        <label className={styles.wrapper__form_item}>
                            <span className={styles.label__wrapper}>شهر</span>
                            <Select
                                className={`c-input p-0 w100-mb ${errors?.city ? "input_error" : ""}`}
                                placeholder={!values.province ? "ابتدا استان را انتخاب کنید" : "انتخاب کنید ..."}
                                getOptionLabel={(option: ICity) => option.name}
                                getOptionValue={(option: ICity) => option._id}
                                options={citiesIsSuccess && cities?.data}
                                value={values?.city}
                                isLoading={citiesIsLoading}
                                isRtl
                                isSearchable
                                captureMenuScroll
                                isDisabled={!values.province || citiesIsLoading}
                                onChange={(val: ICity) => setValues(prev => ({ ...prev, city: val }))}
                                styles={selectStyles}
                                components={{
                                    ClearIndicator: null,
                                    IndicatorSeparator: null,
                                }}
                            />
                            {errors?.city && <span className="input_alert">{errors?.city}</span>}
                        </label>
                    </div>

                </div>
            </div>

            <div className='flex flex-row gap-15 jcb w100'>
                <Button
                    className="flex-grow"
                    id="form-choose-city-province"
                    onClick={() => onSubmit()}
                    animation
                >
                    مرحله بعد
                </Button>
            </div>
        </div>
    )
}

export default memo(FormLocationStep);